export default "__VITE_ASSET__yNtwKDrW__"